import { useEffect, useRef, useState } from 'react';
import WaveSurfer from 'wavesurfer.js';
import { PlayIcon, PauseIcon } from '@heroicons/react/24/solid';

export default function AudioMessage({ src, isSentByYou }) {
  const waveformRef = useRef(null);
  const wavesurferRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [duration, setDuration] = useState("00:00");

  useEffect(() => {
    if (!waveformRef.current) return;

    wavesurferRef.current = WaveSurfer.create({
      container: waveformRef.current,
      waveColor: '#d1d5db',
      progressColor: '#ffffff',
      cursorColor: 'transparent',
      barWidth: 2,
      barRadius: 2,
      dragToSeek: true,
      width: "30vw",
      height: 40,
      responsive: true,
      normalize: true,
    });

    wavesurferRef.current.load(src);

		let totalSeconds = 0;

    wavesurferRef.current.on('ready', () => {
      totalSeconds = wavesurferRef.current.getDuration();
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = Math.floor(totalSeconds % 60).toString().padStart(2, '0');
      setDuration(`${minutes}:${seconds}`);
    });

    wavesurferRef.current.on('audioprocess', () => {
		if (wavesurferRef.current.isPlaying()) {
			const currentTime = wavesurferRef.current.getCurrentTime();
			const remaining = Math.max(totalSeconds - currentTime, 0);
			const minutes = Math.floor(remaining / 60);
			const seconds = Math.floor(remaining % 60).toString().padStart(2, '0');
			setDuration(`${minutes}:${seconds}`);
		}
    });

		wavesurferRef.current.on('finish', () => {
			setIsPlaying(false);
			wavesurferRef.current.seekTo(0);

			const minutes = Math.floor(totalSeconds / 60);
			const seconds = Math.floor(totalSeconds % 60).toString().padStart(2, '0');
			setDuration(`${minutes}:${seconds}`);
		});

    wavesurferRef.current.on('play', () => setIsPlaying(true));
    wavesurferRef.current.on('pause', () => setIsPlaying(false));

    return () => {
      wavesurferRef.current.destroy();
    };
  }, [src]);

  const togglePlay = () => {
    if (wavesurferRef.current) {
      wavesurferRef.current.playPause();
    }
  };

  return (
    <div className={`flex items-center rounded-full px-4 py-2 my-2 w-full max-w-md space-x-3 ${
        isSentByYou ? 'bg-chatBlueColor text-white' : 'bg-chatGrayColor'
    }`}>
      <button
        onClick={togglePlay}
        className="w-8 h-8 flex items-center justify-center rounded-full"
      >
        {isPlaying ? <PauseIcon className="w-5 h-5" /> : <PlayIcon className="w-5 h-5" />}
      </button>

      <div className="flex-1">
        <div ref={waveformRef} className="w-full"></div>
      </div>

      <span className="text-sm min-w-[40px]">{duration}</span>
    </div>
  );
}